import { FC, useState } from 'react';

import {
  Button,
  Col,
  Flex,
  Form,
  FormProps,
  Input,
  Row,
  notification,
} from 'antd';
import { useTranslation } from 'react-i18next';
import useSWR, { mutate } from 'swr';

import Card from '@/components/RCard';
import { handleError } from '@/utils';

import { authApi } from '../../../api';
import PageHeader from '../../../components/RPageHeader';
import { UserResponse } from '../../../types/auth';

const ChangePassword: FC<FormProps> = ({ ...formProps }) => {
  const { t } = useTranslation();
  const { data: user } = useSWR<UserResponse>('/auth/user/me/');
  const [form] = Form.useForm();

  const [isLoading, setIsLoading] = useState(false);

  async function changePass() {
    try {
      setIsLoading(true);
      await form.validateFields();

      const formResult = form.getFieldsValue();
      if (formResult) {
        const body = {
          oldPassword: formResult.password,
          password: formResult.newPassword,
        };
        if (user) {
          const result = await authApi.patchUser(user.id, body);
          if (result) {
            mutate(result);
          }
        }
      }
      notification.success({
        message: t('changePassword.passwordChangedSuccess'),
      });

      setTimeout(() => {
        window.location.reload();
      }, 1000);

      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      handleError(error, t('changePassword.changePasswordFailed'));
    }
  }

  return (
    <>
      <PageHeader
        title={t('changePassword.pageTitle')}
        description={t('changePassword.pageDescription')}
      />
      <Form form={form} layout="vertical" {...formProps}>
        <Card
          // title={
          //   <CardTitleWithButton
          //     title="Change Password"
          //     isLoading={isLoading}
          //     buttonText="Change"
          //     disabled={false}
          //     onClick={() => changePass()}
          //   />
          // }
          title={t('changePassword.title')}
          $paddingBody="24px"
        >
          <Row align="middle" gutter={10} wrap={false}>
            <Col span={8}>
              <Form.Item
                label={t('changePassword.oldPassword.label')}
                name="password"
                rules={[
                  {
                    required: true,
                    message: t('changePassword.oldPassword.requiredMessage'),
                  },
                ]}
              >
                <Input.Password className="w-100" />
              </Form.Item>
            </Col>
          </Row>
          <Row align="middle" gutter={10} wrap={false}>
            <Col span={8}>
              <Form.Item
                label={t('changePassword.newPassword.label')}
                name="newPassword"
                rules={[
                  {
                    required: true,
                    message: t('changePassword.newPassword.requiredMessage'),
                  },
                ]}
              >
                <Input.Password className="w-100" />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                label={t('changePassword.verifyPassword.label')}
                name="verifyPassword"
                rules={[
                  {
                    required: true,
                    message: t('changePassword.verifyPassword.requiredMessage'),
                  },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (!value || getFieldValue('newPassword') === value) {
                        return Promise.resolve();
                      }
                      return Promise.reject(
                        new Error(
                          t('changePassword.verifyPassword.mismatchMessage')
                        )
                      );
                    },
                  }),
                ]}
              >
                <Input.Password className="w-100" />
              </Form.Item>
            </Col>
          </Row>
          <Flex justify="end" style={{ marginTop: '33px' }}>
            <Button
              type="primary"
              loading={isLoading}
              onClick={() => changePass()}
            >
              {t('changePassword.change')}
            </Button>
          </Flex>
        </Card>
      </Form>
    </>
  );
};

export default ChangePassword;
